/**
 * [通过参数名获取url中的参数值]
 * 示例URL:http://htmlJsTest/getrequest.html?uid=admin&rid=1&fid=2&name=小明
 * @param  {[string]} queryName [参数名]
 * @return {[string]}           [参数值]
 */
export function getQueryValue(queryName) {
  var reg = new RegExp("(^|&)" + queryName + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
}

// 格式化路由
export const formatRoutes = function (routes) {
  routes.forEach((route) => {
    // 源信息
    route.meta = route.meta ? route.meta : {}
    route.meta.menuTitle = 0
    route.meta.showMenu = route.comMicsShowMenu
    route.meta.sidebar = route.comMicsShowBar
    route.meta.title = route.webMicsName
    route.meta.hidden = !route.comMicsShow
    route.meta.parentId = route.comMicsPid
    route.meta.disabled = false
    // route.meta.permission = permission
    route.meta.webMicsLevelTwo = route.webMicsLevelTwo ? route.webMicsLevelTwo : null
    route.parentId = route.comMicsPid
    // id 
    route.resourceId = route.comMicsId
    // title
    route.resourceTitle = route.webMicsName
    // path
    route.path = route.comMicsPath ? route.comMicsPath : ''

    redirectUrl(route.children, route);

    // 引用组件  0  为layout,  1、2 为 route-view, 3 为页面 
    route.component = route.comMicsFore == 0 ?
      Layout : route.comMicsFore == 1 ?
      second : route.comMicsFore == 2 ?
      second : resolve => require([`@/views${route.comMicsComponent}`], resolve)
    if (route.comMicsRedirect) {

      route.redirect = route.comMicsRedirect

    } else {
      route.redirect = null
    }
    route.children = route.children ? route.children : [];

    if (route.comMicsFore == 2) {
      if (route.children && route.children.length > 0) {
        let permission = []
        route.children.forEach(item => {
          if (item.comMicsTag) {
            permission.push(item.comMicsTag)
            if (item.comMicsTag == 'home-index') {
              item.meta = {}
              item.meta.permission = permission
            }
          }
        })
      }
    }
    if (route.comMicsFore == 3) {}
    // 删除不必要属性
    delete route.comMicsInstance
    // 递归子级
    if (route.children && route.children.length > 0) {

      formatRoutes(route.children);
    }
  });
};

// 递归查重定向
function redirectUrl(router, route) {
  if (3 == route.comMicsFore) {
    return;
  } else if (!router || 0 >= router.length) {
    return;
  }

  for (let index = 0; index < router.length; index++) {
    redirectUrl(router[index].children, router[index]);
    if (router[index].comMicsPath === route.comMicsRedirect) {
      return;
    }
  }

  // 优先选择home-index列表
  if (3 == router[0].comMicsFore) {
    for (let index = 0; index < router.length; index++) {
      if (router[index].comMicsTag === 'home-index') {
        route.comMicsRedirect = router[index].comMicsPath;
        return;
      }
    }
  }
  // 选择第一个
  route.comMicsRedirect = router[0].comMicsPath;
}
export const deepCopy = function (obj, cache = []) {
  // typeof [] => 'object'
  // typeof {} => 'object'
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  // 如果传入的对象与缓存的相等, 则递归结束, 这样防止循环
  /**
   * 类似下面这种
   * var a = {b:1}
   * a.c = a
   * 资料: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
   */
  const hit = cache.filter((c) => c.original === obj)[0];
  if (hit) {
    return hit.copy;
  }

  const copy = Array.isArray(obj) ? [] : {};
  // 将copy首先放入cache, 因为我们需要在递归deepCopy的时候引用它
  cache.push({
    original: obj,
    copy,
  });
  Object.keys(obj).forEach((key) => {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
};

const title = "";

export function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}

export function getRouteTile(to) {
  return to.meata.title;
}

export const haveWeb = () => {
  let routers = JSON.parse(window.localStorage.getItem("router") || "[]");
  let List = new initList(routers, "children").formatting || [];
  return List.some((val, ind) => {
    if (val.path == "/fusionRelease/webRelease/list" && !val.meta.hidden) {
      return true;
    } else {
      return false;
    }
  });
};

export const haveApp = () => {
  let routers = JSON.parse(window.localStorage.getItem("router") || "[]");
  let List = new initList(routers, "children").formatting || [];
  return List.some((val, ind) => {
    if (val.path == "/fusionRelease/appRelease/list" && !val.meta.hidden) {
      return true;
    } else {
      return false;
    }
  });
};
export const haveThird = () => {
  let routers = JSON.parse(window.localStorage.getItem("router") || "[]");
  let List = new initList(routers, "children").formatting || [];
  return List.some((val, ind) => {
    if (val.path == "/fusionRelease/tripartiteRelease/list" && !val.meta.hidden) {
      return true;
    } else {
      return false;
    }
  });
};
export class initTreeList {
  constructor(arr, pidName, initialPid, idName) {
    this.arr = arr;
    this.formatting = arr.filter((val, ind) => {
      if (val[pidName] == initialPid) {
        if (this.findChild(val[idName], pidName, idName).length > 0) {
          val.children = this.findChild(val[idName], pidName, idName);
        }
        return true;
      } else {
        return false;
      }
    });
    return this;
  }
  findChild(id, pidName, idName) {
    return this.arr.filter((val, ind) => {
      if (val[pidName] == id) {
        if (this.findChild(val[idName], pidName, idName).length > 0) {
          val.children = this.findChild(val[idName], pidName, idName);
        }
        return true;
      } else {
        return false;
      }
    });
  }
}
export class initList {
  constructor(arr, childrenName) {
    this.arr = arr;
    this.formatting = [];
    this.getChild(arr, childrenName);
  }
  getChild(arrChild, childrenName) {
    arrChild.forEach((val, ind) => {
      this.formatting.push(val);
      if (val[childrenName]) {
        this.getChild(val[childrenName], childrenName);
      }
    });
  }
}


// 对象转formData
export function ObjToFormData(obj) {
  const formData = new FormData()
  Object.keys(obj).forEach(key => {
    formData.append(key, obj[key])
  })
  return formData
}
/**
 * 事件防抖  多用于click
 */
let timeout = null;
/**
 * 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才执行函数
 *
 * @param {Function} func 要执行的回调函数
 * @param {Number} wait 延时的时间
 * @param {Boolean} immediate 是否立即执行
 * @return null
 */
export function debounce(func, wait = 200, immediate = false) {
  // 清除定时器
  if (timeout !== null) clearTimeout(timeout);
  // 立即执行，此类情况一般用不到
  if (immediate) {
    var callNow = !timeout;
    timeout = setTimeout(function () {
      timeout = null;
    }, wait);
    if (callNow) typeof func === 'function' && func();
  } else {
    // 设置定时器，当最后一次操作后，timeout不会再被清除，所以在延时wait毫秒后执行func回调方法
    timeout = setTimeout(function () {
      typeof func === 'function' && func();
    }, wait);
  }
}


let worker = null
// 分片上传
export async function chunkUpload(file, fileLibId) {
  const fileChunkList = createFileChunk(file);
  file.hash = await calculateHash(fileChunkList);
  const verifyRes = await verifyUpload(
    file.name,
    file.hash,
    fileLibId
  );
  // verifyRes.data>0 代表此文件已经上传过走妙传
  if (verifyRes.data.code == 200 && verifyRes.data.data.fileResId > 0) {
    //秒传接口
    let secondPassType = await isAllStatus(
      fileLibId,
      verifyRes.data.data.fileResId,
      file.name
    );
    if (secondPassType.code == 200 && secondPassType.data > 0) {
      Message({
        type: "success",
        message: '上传成功',
      });
      worker.terminate()
      return secondPassType.data
    }
  } else if (
    verifyRes.data.code == 200 &&
    verifyRes.data.data.fileResId < 0
  ) {
    file.pauseIndex = verifyRes.data.data.curChunk;
    for (let p = 0; p < fileChunkList.length; p++) {
      if (file.pauseIndex > p) {
        continue;
      } else {
        //切片的MD5
        let chunkMd5 = await calculateHash([fileChunkList[p]]);
        //校验切片是否存在
        let res = await chunkUploadList(
          chunkMd5,
          p,
          fileLibId,
          file.hash
        );
        if (res.data.data < 0 && res.data.code == 200) {
          //分片不存在
          const formData = new FormData();
          formData.append("chunkCount", fileChunkList.length);
          formData.append("chunkMd5", chunkMd5);
          formData.append("curChunk", p);
          formData.append("fileLibId", fileLibId);
          formData.append("md5", file.hash);
          formData.append("originalFileName", file.name);
          formData.append("file", fileChunkList[p].file);
          let data = await new Promise((resolve) => {
            getChunkUp(formData)
              .then((res) => {
                resolve(res);
              })
              .catch((err) => {
                console.log("verifyUpload -> err", err);
              });
          });
          if (data.data.code == 200) {
            // console.log("第" + p + "上传成功", data);
            if (data.data.data && data.data.data > 0) {
              Message({
                type: "success",
                message: '上传成功',
              });
              worker.terminate()
              return data.data.data
            }
          }
        } else if (res.data.data > 0 && res.data.code == 200) {
          // console.log("第" + p + "片上传过");
        } else {
          console.log("切片检验失败");
        }
      }
    }
  }
}

function createFileChunk(file, size = 5 * 1024 * 1024) {
  const fileChunkList = [];
  var count = 0;
  while (count < file.size) {
    fileChunkList.push({
      file: file.slice(count, count + size),
      start: count,
      end: count + size,
    });
    count += size;
  }
  return fileChunkList;
}

function calculateHash(fileChunkList) {
  return new Promise((resolve) => {
    worker = new Worker("/hash.js");
    worker.postMessage({
      fileChunkList
    });
    worker.onmessage = (e) => {
      const {
        percentage,
        hash
      } = e.data;
      if (hash) {
        resolve(hash);
      }
    };
  });
}

function verifyUpload(fileName, fileHash, fileLibId) {
  return new Promise((resolve) => {
    const obj = {
      md5: fileHash,
      fileLibId: fileLibId,
      fileObjName: fileName,
    };
    getcheckCopy(obj)
      .then((res) => {
        // console.log("verifyUpload -> res", res);
        resolve(res);
      })
      .catch((err) => {
        // console.log("verifyUpload -> err", err);
      });
  });
}

function isAllStatus(fileLibId, fileId, name) {
  return new Promise((resolve, reject) => {
    setStore({
        fileLibId: fileLibId,
        fileObjName: name,
        fileResId: fileId,
      })
      .then(({
        data
      }) => {
        if (data.code == 200) {
          resolve(data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function chunkUploadList(chunk, index, fileId, allMd5) {
  var formData = new FormData();
  formData.append("chunkMd5", chunk);
  formData.append("curChunk", index);
  formData.append("fileLibId", fileId);
  formData.append("md5", allMd5);
  return new Promise((resolve) => {
    getChunk(formData)
      .then((res) => {
        console.log("verifyUpload -> res", res);
        resolve(res);
      })
      .catch((err) => {
        console.log("verifyUpload -> err", err);
      });
  });
}
const contentProductionAndLivePublishLimits = [{
    label: '文稿',
    routerType: 'manuscripts',
    powerType: '/contentProduction/manuscripts',
  },
  {
    label: '图集',
    routerType: 'atlas',
    powerType: '/contentProduction/newAtlas',
  },
  {
    label: '视频',
    routerType: 'video',
    powerType: '/contentProduction/newVideo',
  },
  {
    label: '音频',
    routerType: 'audio',
    powerType: '/contentProduction/newAudio',
  },
  {
    label: '外链',
    routerType: 'externallinks',
    powerType: '/contentProduction/externalLinks',
  },
  {
    label: '活动直播',
    routerType: '8',
    powerType: '/contentManagement/cloudLiveBroadcast/liveBroadcastActivities',
  },
  {
    label: '电视直播',
    routerType: '6',
    powerType: '/contentManagement/cloudLiveBroadcast/tvLiveBroadcast',
  },
  {
    label: '电台直播',
    routerType: '7',
    powerType: '/contentManagement/cloudLiveBroadcast/liveBroadcastRadioStation',
  },
  {
    label: '虚拟直播',
    routerType: '10',
    powerType: '/contentManagement/cloudLiveBroadcast/liveVroadcastFictitious',
  },
  {
    label: '慢直播',
    routerType: '16',
    powerType: '/contentManagement/cloudLiveBroadcast/liveVroadcastFictitious',
  },
]
const contentProductionPublishLimits = [{
    label: '文稿',
    routerType: 'manuscripts',
    powerType: '/contentProduction/manuscripts',
  },
  {
    label: '图集',
    routerType: 'atlas',
    powerType: '/contentProduction/newAtlas',
  },
  {
    label: '视频',
    routerType: 'video',
    powerType: '/contentProduction/newVideo',
  },
  {
    label: '音频',
    routerType: 'audio',
    powerType: '/contentProduction/newAudio',
  },
  {
    label: '外链',
    routerType: 'externallinks',
    powerType: '/contentProduction/externalLinks',
  },
]

function contentProductionAndLivePublishLimitsFilter(type) {
  return contentProductionAndLivePublishLimits.find(val => {
    return val.routerType == type
  })
}

function contentProductionPublishLimitsFilter(type) {
  return contentProductionPublishLimits.find(val => {
    return val.routerType == type
  })
}
/**
 * @queryType 路由传参的type类型，用于从枚举中获取路由地址
 * @type 区分内容生产、直播和专题模块， 1 内容生产
 */
export const appPublishPower = (queryType) => {
  if (!contentProductionAndLivePublishLimitsFilter(queryType)) return false
  let routers = JSON.parse(window.localStorage.getItem("router") || "[]");
  let List = new initList(routers, "children").formatting || [];
  return List.some((val, ind) => {
    if (val.path == `${contentProductionAndLivePublishLimitsFilter(queryType).powerType}/pubApp`) {
      return true;
    } else {
      return false;
    }
  });
}
/**
 * @queryType 路由传参的type类型，用于从枚举中获取路由地址
 * @type 区分内容生产、直播和专题模块， 1 内容生产， 2  直播， 3  专题
 */
export const webPublishPower = (queryType, type) => {
  if (!contentProductionAndLivePublishLimitsFilter(queryType)) return false
  let routers = JSON.parse(window.localStorage.getItem("router") || "[]");
  let List = new initList(routers, "children").formatting || [];
  return List.some((val, ind) => {
    if (val.path == `${contentProductionAndLivePublishLimitsFilter(queryType).powerType}/pubWeb`) {
      return true;
    } else {
      return false;
    }
  });
}
/**
 * @queryType 路由传参的type类型，用于从枚举中获取路由地址
 * @type 区分内容生产、直播和专题模块， 1 内容生产， 2  直播， 3  专题
 */
export const xyWebPublishPower = (queryType, type) => {
  if (!contentProductionAndLivePublishLimitsFilter(queryType)) return false
  let routers = JSON.parse(window.localStorage.getItem("router") || "[]");
  let List = new initList(routers, "children").formatting || [];
  return List.some((val, ind) => {
    if (val.path == `${contentProductionAndLivePublishLimitsFilter(queryType).powerType}/pubClient`) {
      return true;
    } else {
      return false;
    }
  });
}
/**
 * @queryType 路由传参的type类型，用于从枚举中获取路由地址
 * @type 区分内容生产、直播和专题模块， 1 内容生产， 2  直播， 3  专题
 */
export const thirdPublishPower = (queryType, type) => {
  if (type == 1) {
    if (!contentProductionPublishLimitsFilter(queryType)) return false
    let routers = JSON.parse(window.localStorage.getItem("router") || "[]");
    let List = new initList(routers, "children").formatting || [];
    return List.some((val, ind) => {
      if (val.path == `${contentProductionPublishLimitsFilter(queryType).powerType}/pubTripart`) {
        return true;
      } else {
        return false;
      }
    });
  }
}
/**
 * @type 区分按钮功能类型
 */
export const reviewPower = ( type) => {
  if(!type) return false
    let routers = JSON.parse(window.localStorage.getItem("router") || "[]");
    let List = new initList(routers, "children").formatting || [];
    return List.some((val, ind) => {
      if (val.path == `/contentProduction/review/${type}`) {
        return true;
      } else {
        return false;
      }
    });
}